/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Components */
import SwimlaneSkeleton from '../SwimlaneSkeleton';

/* Styles */
import './SwimlaneCollectionSkeleton.scss';

const NUMBER_OF_CARDS = 5;

function SwimlaneCollectionSkeleton({
  withTitle,
}) {
  return (
    <SwimlaneSkeleton withTitle={withTitle}>
      {Array.from({ length: NUMBER_OF_CARDS }).fill().map((value, index) => (
        <Skeleton
          // eslint-disable-next-line react/no-array-index-key -- only presentational
          key={index}
          className="dtv-html5-c-swimlane-collection-skeleton__card"
        />
      ))}
    </SwimlaneSkeleton>
  );
}

SwimlaneCollectionSkeleton.propTypes = {
  withTitle: PropTypes.bool,
};

SwimlaneCollectionSkeleton.defaultProps = {
  withTitle: true,
};

export default memo(SwimlaneCollectionSkeleton);
